import { useCallback } from 'react';
import { useActivateRevisionMutation } from '../api/mutation.activate.js';
import { useDeactivateRevisionMutation } from '../api/mutation.deactivate.js';

function useActivateRevision(courseId) {
  const activateMutation = useActivateRevisionMutation(courseId);
  const deactivateMutation = useDeactivateRevisionMutation(courseId);
  return useCallback(revision => {
    if (revision !== "default") {
      return activateMutation.mutate(revision);
    } else {
      return deactivateMutation.mutate(undefined);
    }
  }, [activateMutation, deactivateMutation]);
}

export { useActivateRevision };
//# sourceMappingURL=activate.js.map
